import React from 'react';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Partner } from '../../types/api';
import { hasCoordinates } from '../../utils/coordinates';

interface VenueMapProps {
  partner: Partner | null;
  /** Открыть форму сразу на разделе «Расположение». */
  onEdit: () => void;
}

const markerIcon = L.icon({
  iconUrl: process.env.PUBLIC_URL + '/marker-icon.svg',
  iconSize: [32, 48],
  iconAnchor: [16, 48],
  popupAnchor: [0, -48],
  shadowUrl: undefined,
});

export const VenueMap: React.FC<VenueMapProps> = ({ partner, onEdit }) => {
  // Координаты приходят строкой ("0.0000000" — правда для Boolean), поэтому
  // проверяем общим правилом: 0°/0° — не точка (ADR-014).
  const hasPoint = hasCoordinates(partner?.latitude, partner?.longitude);

  return (
    <section className="qp-panel">
      <header className="qp-panel-head">
        <h2 className="qp-label">Адрес</h2>
        <button type="button" className="qp-link" onClick={onEdit}>
          Изменить
        </button>
      </header>

      <p style={{ margin: '0 0 14px', fontSize: 14, color: 'var(--qp2-muted)' }}>
        {partner?.address || 'Адрес не указан'}
      </p>

      {!hasPoint && (
        <div className="qp-notice qp-notice--error" role="status">
          <span>Точка на карте не поставлена — гости не видят расстояние до вас и не построят маршрут.</span>
          <button type="button" className="qp-link" onClick={onEdit}>
            Поставить точку
          </button>
        </div>
      )}

      {hasPoint && (
        <div className="qp-map">
          <MapContainer
            center={[Number(partner?.latitude), Number(partner?.longitude)]}
            zoom={16}
            scrollWheelZoom={false}
            style={{ height: '100%', width: '100%' }}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[Number(partner?.latitude), Number(partner?.longitude)]} icon={markerIcon} />
          </MapContainer>
        </div>
      )}
    </section>
  );
};
